import { Button as AntButton, Descriptions, Modal, Select } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IStudent } from '../../../../../models/students.model';
import {
  IGetStudentPaymentsDetails,
  IPostStudentPaymentTodo,
  IStudentBreakdown,
} from '../../../../../models/payments.model';
import styled from 'styled-components';
import useAxios from '../../../../../hooks/useAxios';
import useLoader from '../../../../../hooks/useLoader';
import {
  createTempPaymentTodo,
  createTossPaymentTodo,
  getStudentPaymentsDetailsTodo,
  replacePaymentTodo,
} from '../../../../../api/payments.api';
import { getTossInstallment } from '../../../../../lib/toss';
import PaymentDetailTable from '../PaymentDetailTable';
import useUtil from '../../../../../hooks/useUtil';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { getInstallment } from '../../../../../lib/util';
import StudentPaymentProcessModal from '../../modals/PaymentProcessModal';
import { IGetPgSetting } from '../../../../../models/campuses.model';
import { getPgSetting } from '../../../../../api/campuses.api';
import { campusHeadOffice } from '../../../../../lib/data';
import useToss from '../../../../../hooks/useToss';
import useNotification from '../../../../../hooks/useNotification';
import usePayment from '../../../../../hooks/usePayment';
import useNicePayModule from '../../../../../hooks/useNicePayModule';
import PaymentChangePosProcessModal from './PaymentChangePosProcessModal';
import {
  createNicePaymentTodo,
  createTempNicePaymentTodo,
  getPosResultInfo,
  postNicePaymentLog,
  replaceNicePaymentTodo,
  replaceNiceVanPaymentTodo,
} from '../../../../../api/nicePayments.api';
import useReceiptPrinterModule from '../../../../../hooks/useReceiptPrinterModule';
import { IGetPosResultInfo } from '../../../../../models/nicePayments.model';

const Block = styled.div`
    margin-top: -40px;

    .table-mini {
        width: 400px;
    }

    .arrow > * {
        margin: 65px 10px 0 10px;
        font-size: 30px;
    }
`;

const selectInstallment: string[] = ['일시불', ...getInstallment()];

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  student?: IStudent;
  paymentRecord?: IStudentBreakdown;
  setPaymentRecord: (paymentRecord: undefined) => void;
  getStudentPaymentMade: () => void;
  sendLog: (message: string, object?: object) => void;
}

const ChangePaymentModal: FC<IProps> = ({
                                          visible,
                                          setVisible,
                                          student,
                                          paymentRecord,
                                          setPaymentRecord,
                                          getStudentPaymentMade,
                                          sendLog,
                                        }) => {
  const { t } = useTranslation();
  const { successNotification, errorNotification } = useNotification();
  const { getCommonCodeLabel } = useUtil();
  const { handleTossResponse } = usePayment();
  const { data: res, isLoading, error, execute } = useAxios<IPostStudentPaymentTodo>();
  const { printReceipt } = useReceiptPrinterModule();
  const {
    execute: nicePosExecute1,
    error: nicePosError1,
    data: nicePosRes1,
    isLoading: nicePosIsLoading1,
  } = useNicePayModule();
  const {
    execute: nicePosExecute2,
    error: nicePosError2,
    data: nicePosRes2,
    isLoading: nicePosIsLoading2,
  } = useNicePayModule();
  const {
    execute: nicePosExecute3,
    error: nicePosError3,
    data: nicePosRes3,
    isLoading: nicePosIsLoading3,
  } = useNicePayModule();
  const { execute: niceLogExecute } = useAxios();
  const {
    data: posInfoRes,
    isLoading: posInfoResIsLoading,
    error: posInfoResError,
    execute: posInfoResExecute,
  } = useAxios<IGetPosResultInfo>();
  const {
    data: posInfoRes2,
    isLoading: posInfoResIsLoading2,
    error: posInfoResError2,
    execute: posInfoResExecute2,
  } = useAxios<IGetPosResultInfo>();
  const { data: niceRes3, isLoading: niceIsLoading3, error: niceError3, execute: niceExecute3 } = useAxios();
  const { data: niceRes4, isLoading: niceIsLoading4, error: niceError4, execute: niceExecute4 } = useAxios();
  const { data: niceVanRes, isLoading: niceVanIsLoading, error: niceVanError, execute: niceVanExecute } = useAxios();

  const { data: tossRes, error: tossError, execute: tossExecute } = useToss();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetPgSetting>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios();
  const { data: res4, isLoading: isLoading4, error: error4, execute: execute4 } = useAxios();
  const {
    data: detailRes,
    isLoading: detailIsLoading,
    error: detailError,
    execute: detailExecute,
  } = useAxios<IGetStudentPaymentsDetails>();
  useLoader(
    isLoading || isLoading2 || isLoading3 || isLoading4,
    [error, error2, error3, error4],
  );

  const [installment, setInstallment] = useState('일시불');
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [paymentRecordCode, setPaymentRecordCode] = useState<number>();
  const [awaitTossVisible, setAwaitTossVisible] = useState(false);

  const [awaitNiceVisible, setAwaitNiceVisible] = useState(false);
  const [nicePaymentStep, setNicePaymentStep] = useState<'FIRST' | 'FIRST-FAIL' | 'SECOND' | 'SECOND-FAIL' | 'SECOND-VAN-FAIL' | 'THIRD' | 'THIRD-FAIL' | 'COMPLETE' | 'CANCEL'>('FIRST');
  const [niceErrorMessage, setNiceErrorMessage] = useState<string>();

  const onSubmit = () => {
    if (!student || !paymentRecord) {
      return;
    }

    if (paymentRecord?.pgCompany === 'TOSS') {
      execute(createTempPaymentTodo(
        student.studentCode,
        paymentRecord.paymentRecordCode,
        { installment: Number(getTossInstallment(installment)) },
      ));
    } else if (paymentRecord?.pgCompany === 'NICE') {
      execute(createTempNicePaymentTodo(
        student.studentCode,
        paymentRecord.paymentRecordCode,
        { installment: Number(getTossInstallment(installment)) },
      ));
    }

    sendLog('createTempPaymentTodo', {
      studentCode: student.studentCode,
      paymentRecordCode: paymentRecord.paymentRecordCode,
      installment: Number(getTossInstallment(installment)),
    });
  };

  const convertInstallment = (installmentPlanMonth: string) => {
    return installmentPlanMonth !== '일시불' ? installmentPlanMonth.padStart(2, '0') : '00';
  };


  useEffect(() => {
    if (paymentRecord?.paymentRecordCode) {
      detailExecute(getStudentPaymentsDetailsTodo(paymentRecord.paymentRecordCode));
    }
  }, [paymentRecord]);

  // ---------------------------- [ Nice Pos Flow ] ----------------------------
  const handleNicePaymentAmountCalculation = async () => {
    if (res?.data?.details?.length && paymentRecord?.pgCompany === 'NICE') {
      const paymentRecordCode = res.data.paymentRecordCode;
      const totalPrice = res.data.details.reduce((acc, cur) => acc + cur.price, 0);
      const convertInstallmentData = convertInstallment(installment);
      const totalDiscount = res.data.details.reduce((acc, cur) => acc + cur.discountAmount, 0);
      const taxAmt = res!.data.taxAmt || 0;
      const catId = res?.data.catId;

      setPaymentAmount(totalPrice - totalDiscount);
      setNicePaymentStep('FIRST');
      setAwaitNiceVisible(true);

      try {
        await nicePosExecute1('approve', paymentRecordCode, totalPrice - totalDiscount, convertInstallmentData, taxAmt, '', '', catId);
      } catch (err) {
        setNicePaymentStep('FIRST-FAIL');
        setNiceErrorMessage(err instanceof Error && err?.message ? err.message : '결제 실패');
      }
    }
  };

  const handleNiceResponseProcessing = () => {
    if (nicePosRes1 && paymentRecord?.pgCompany === 'NICE') {
      const req = { ...nicePosRes1, change: true, oid: res?.data.paymentRecordCode, tamt: nicePosRes1.totalAmount };
      niceExecute3(createNicePaymentTodo(req));
      sendLog('createNicePaymentTodo', req);
    }
  };

  const handleNiceRefundFlowSelectProcessing = async (isRestart: boolean = false) => {
    if (res?.data.paymentRecordCode && !isRestart) {
      // await printReceipt(res.data.paymentRecordCode);
    }

    if (niceRes3 && paymentRecord?.pgCompany === 'NICE' && paymentRecord.paymentMethodDetailCode === '01') {
      posInfoResExecute(getPosResultInfo(paymentRecord.paymentRecordCode));
      sendLog('getPosResultInfo', {
        paymentRecordCode: paymentRecord.paymentRecordCode,
      });
    } else if (niceRes3 && paymentRecord?.pgCompany === 'NICE' && paymentRecord.paymentMethodDetailCode === '02') {
      niceVanExecute(replaceNiceVanPaymentTodo(
        paymentRecord!.paymentRecordCode,
        res?.data.paymentRecordCode!,
      ));
      sendLog('replaceNiceVanPaymentTodo', {
        oldPaymentRecordCode: paymentRecord!.paymentRecordCode,
        newPaymentRecordCode: res?.data.paymentRecordCode!,
      });
    }
  };

  const handleReplaceNiceVanPaymentTodoError = () => {
    if (niceVanError) {
      setNicePaymentStep('SECOND-VAN-FAIL');
      setNiceErrorMessage(niceVanError?.message ?? '환불 실패');
      errorNotification(niceVanError?.response?.data?.data ?? '환불 실패');
    }
  };

  const handleNiceRefundFlowResetProcessing = () => {
    if (res?.data.paymentRecordCode) {
      posInfoResExecute2(getPosResultInfo(res?.data.paymentRecordCode));
      sendLog('getPosResultInfo', {
        paymentRecordCode: res?.data.paymentRecordCode,
      });
    }
  };

  const handleNicePosRefundProcessing = async () => {
    if (posInfoRes?.data && paymentRecord) {
      const paymentRecordCode = paymentRecord?.paymentRecordCode;
      const totalPrice = posInfoRes?.data.totalAmount;
      const installmentMonths = posInfoRes?.data.installmentMonths;
      const taxAmt = posInfoRes?.data.vatAmount;
      const approvalNumber = posInfoRes?.data.approvalNumber;
      const transactionDate = posInfoRes?.data.transactionDate;
      const catId = posInfoRes?.data.catId;

      setNicePaymentStep('SECOND');
      setAwaitNiceVisible(true);

      try {
        await nicePosExecute2('cancel', paymentRecordCode, Number.parseInt(totalPrice), installmentMonths, Number.parseInt(taxAmt), approvalNumber, transactionDate, catId);
      } catch (err) {
        setNicePaymentStep('SECOND-FAIL');
        setNiceErrorMessage(err instanceof Error && err?.message ? err.message : '환불 실패');
      }
    }
  };

  const handleNicePosResetRefundProcessing = async () => {
    if (posInfoRes2?.data && paymentRecord) {
      const paymentRecordCode = paymentRecord?.paymentRecordCode;
      const totalPrice = posInfoRes2?.data.totalAmount;
      const installmentMonths = posInfoRes2?.data.installmentMonths;
      const taxAmt = posInfoRes2?.data.vatAmount;
      const approvalNumber = posInfoRes2?.data.approvalNumber;
      const transactionDate = posInfoRes2?.data.transactionDate;
      const catId = posInfoRes2?.data.catId;

      setNicePaymentStep('THIRD');
      setAwaitNiceVisible(true);

      try {
        await nicePosExecute3('cancel', paymentRecordCode, Number.parseInt(totalPrice), installmentMonths, Number.parseInt(taxAmt), approvalNumber, transactionDate, catId);
      } catch (err) {
        setNicePaymentStep('THIRD-FAIL');
        setNiceErrorMessage(err instanceof Error && err?.message ? err.message : '환불 실패');
      }
    }
  };


  const handleNiceReplacePaymentTodo = () => {
    if (nicePosRes2 && nicePosRes2.success) {
      niceExecute4(replaceNicePaymentTodo(
        paymentRecord!.paymentRecordCode,
        res?.data.paymentRecordCode!,
        { ...nicePosRes2, tamt: nicePosRes2.totalAmount, isFailComplete: false },
      ));
      sendLog('replaceNicePosPaymentTodo', {
        oldPaymentRecordCode: paymentRecord!.paymentRecordCode,
        newPaymentRecordCode: res?.data.paymentRecordCode!,
        body: { ...nicePosRes2, tamt: nicePosRes2.totalAmount, isFailComplete: false },
      });
    }
  };

  const handleResetNiceReplacePaymentTodo = () => {
    if (nicePosRes3 && nicePosRes3.success) {
      niceExecute4(replaceNicePaymentTodo(
        paymentRecord!.paymentRecordCode,
        res?.data.paymentRecordCode!,
        { ...nicePosRes3, tamt: nicePosRes3.totalAmount, isFailComplete: true },
      ));
      sendLog('replaceNicePosPaymentTodo', {
        oldPaymentRecordCode: paymentRecord!.paymentRecordCode,
        newPaymentRecordCode: res?.data.paymentRecordCode!,
        body: { ...nicePosRes3, tamt: nicePosRes3.totalAmount, isFailComplete: true },
      });
    }
  };

  const complete = () => {
    if (niceRes4 || niceVanRes) {
      if (nicePaymentStep === 'THIRD') {
        setNicePaymentStep('CANCEL');
      } else {
        setNicePaymentStep('COMPLETE');
      }
    }
  };

  useEffect(() => {
    handleNicePaymentAmountCalculation();
  }, [res]);
  useEffect(handleNiceResponseProcessing, [nicePosRes1]);
  useEffect(() => setNicePaymentStep('FIRST-FAIL'), [niceError3]);
  useEffect(() => {
    handleNiceRefundFlowSelectProcessing();
  }, [niceRes3]);
  useEffect(() => {
    handleNicePosRefundProcessing();
  }, [posInfoRes]);
  useEffect(() => {
    handleNicePosResetRefundProcessing();
  }, [posInfoRes2]);
  useEffect(handleNiceReplacePaymentTodo, [nicePosRes2]);
  useEffect(handleReplaceNiceVanPaymentTodoError, [niceVanError]);
  useEffect(handleResetNiceReplacePaymentTodo, [nicePosRes3]);
  useEffect(complete, [niceRes4, niceVanRes]);

  useEffect(() => {
    if (nicePosRes1 && nicePosError1 && !nicePosIsLoading1) {
      if(!nicePosRes1.success) {
        console.log('nicePosRes1', nicePosRes1);
        errorNotification(nicePosError1);
        niceLogExecute(postNicePaymentLog(nicePosRes1));
      }
    }
  }, [nicePosRes1, nicePosError1, nicePosIsLoading1]);

  useEffect(() => {
    if (nicePosRes2 && nicePosError2 && !nicePosIsLoading2) {
      if(!nicePosRes2.success) {
        console.log('nicePosRes2', nicePosRes2);
        errorNotification(nicePosError2);
        niceLogExecute(postNicePaymentLog(nicePosRes2));
      }
    }
  }, [nicePosRes2, nicePosError2, nicePosIsLoading2]);

  useEffect(() => {
    if (nicePosRes3 && nicePosError3 && !nicePosIsLoading3) {
      if(!nicePosRes3.success) {
        console.log('nicePosRes3', nicePosRes3);
        errorNotification(nicePosError3);
        niceLogExecute(postNicePaymentLog(nicePosRes3));
      }
    }
  }, [nicePosRes3, nicePosError3, nicePosIsLoading3]);


  // ---------------------------- [ Nice Pos Flow ] ----------------------------


  // ---------------------------- [ Toss Flow ] ----------------------------
  const handleTossPaymentAmountCalculation = () => {
    if (res?.data?.details?.length && paymentRecord?.pgCompany === 'TOSS') {
      const totalPrice = res.data.details.reduce((acc, cur) => acc + cur.price, 0);
      const totalDiscount = res.data.details.reduce((acc, cur) => acc + cur.discountAmount, 0);
      setPaymentAmount(totalPrice - totalDiscount);
      execute2(getPgSetting(
        res.data.details[0].paymentTargetCode === 'ON' || res.data.details[0].paymentTargetCode === 'AL'
          ? campusHeadOffice
          : student!.campusCode,
      ));
    }
  };

  const handleTossPgSettingResponse = () => {
    if (res2 && paymentRecord?.pgCompany === 'TOSS') {
      const newPaymentRecordCode = res!.data.paymentRecordCode;
      const taxAmt = res!.data.taxAmt || 0;
      const taxFreeAmount = res!.data.taxFreeAmount || 0;
      const orderName = res!.data.orderName || '';

      if (newPaymentRecordCode) {
        setPaymentRecordCode(newPaymentRecordCode);
        setAwaitTossVisible(true);
        tossExecute(
          String(newPaymentRecordCode),
          paymentAmount,
          installment,
          res2.data.posMid,
          taxAmt,
          taxFreeAmount,
          orderName,
          student!.studentKorName,
        );
      }
    }
  };

  const handleTossResponseProcessing = () => {
    if (tossRes && paymentRecord?.pgCompany === 'TOSS') {
      const tossResult = handleTossResponse(tossRes);
      const req = { ...tossResult, change: true };
      execute3(createTossPaymentTodo(req));
      sendLog('createTossPaymentTodo', req);
    }
  };

  const handleTossReplacePaymentTodo = () => {
    if (res3 && paymentRecord?.pgCompany === 'TOSS') {
      execute4(replacePaymentTodo(
        paymentRecord!.paymentRecordCode,
        paymentRecordCode!,
      ));
      sendLog('replacePaymentTodo', {
        oldPaymentRecordCode: paymentRecord!.paymentRecordCode,
        newPaymentRecordCode: paymentRecordCode!,
      });
    }
  };

  const handleTossFinalPaymentSuccess = () => {
    if (res4 && paymentRecord?.pgCompany === 'TOSS') {
      getStudentPaymentMade();
      successNotification(t('student.student.message31'));
      setPaymentRecord(undefined);
      setAwaitTossVisible(false);
      setVisible(false);
    }
  };

  const handleTossError = () => {
    if (tossError && paymentRecord?.pgCompany === 'TOSS') {
      alert(t('student.student.message32'));
      setAwaitTossVisible(false);
    }
  };

  useEffect(handleTossPaymentAmountCalculation, [res]);
  useEffect(handleTossPgSettingResponse, [res2]);
  useEffect(handleTossResponseProcessing, [tossRes]);
  useEffect(handleTossReplacePaymentTodo, [res3]);
  useEffect(handleTossFinalPaymentSuccess, [res4]);
  useEffect(handleTossError, [tossError]);

  // ---------------------------- [ Toss Flow ] ----------------------------

  return (
    <>
      <Modal
        title={t('student.student.button9')}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={750}
        footer={[
          <div className="comm-btn__area justify-content-center">
            <AntButton
              key="submit"
              className="btn-basic pink"
              onClick={onSubmit}
            >
              {t('student.student.button17')}
            </AntButton>
            <AntButton
              key="cancel"
              className="btn-basic gray"
              onClick={() => setVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>,
        ]}
      >
        <Block>
          {paymentRecord && (
            <PaymentDetailTable
              paymentRecordDetails={detailRes?.data ?? []}
            />
          )}
          <div className="flex">
            <div className="table-mini">
              <Descriptions
                column={1}
                size="small"
                bordered
              >
                <Descriptions.Item label={t('student.student.column82')}>
                  {
                    paymentRecord?.paymentChannelCode === 'PO'
                      ? 'POS'
                      : 'ONLINE'
                  }
                </Descriptions.Item>
                <Descriptions.Item label={t('student.student.column83')}>
                  {getCommonCodeLabel('PA0002', paymentRecord?.paymentMtdCode)}
                </Descriptions.Item>
                <Descriptions.Item label={t('student.student.column84')}>
                  {
                    paymentRecord?.allotmentMM
                      ? `${paymentRecord?.allotmentMM}${t('student.student.73')}`
                      : t('student.student.74')
                  }
                </Descriptions.Item>
                <Descriptions.Item label={t('student.student.column86')}>
                  {paymentRecord?.totalPaymentAmount?.toLocaleString()}
                </Descriptions.Item>
              </Descriptions>
            </div>
            <div className="arrow">
              <AiOutlineArrowRight />
            </div>
            <div className="table-mini">
              <Descriptions
                column={1}
                size="small"
                bordered
              >
                <Descriptions.Item label={t('student.student.column84')}>
                  <Select
                    className="w-100"
                    placeholder={t('student.student.placeholder6')}
                    value={installment}
                    onChange={value => setInstallment(value)}
                    disabled={
                      !paymentRecord ||
                      paymentRecord.totalPaymentAmount < 50000
                    }
                  >
                    {selectInstallment.map((text, index) => (
                      <Select.Option
                        key={index}
                        value={text}
                      >
                        {text}
                      </Select.Option>
                    ))}
                  </Select>
                </Descriptions.Item>
                <Descriptions.Item label={t('student.student.column86')}>
                  {paymentRecord?.totalPaymentAmount?.toLocaleString()}
                </Descriptions.Item>
              </Descriptions>
            </div>
          </div>
        </Block>
      </Modal>

      {awaitTossVisible && (
        <StudentPaymentProcessModal
          visible={awaitTossVisible}
          onCancel={() => setAwaitTossVisible(false)}
        />
      )}

      {awaitNiceVisible && (
        <PaymentChangePosProcessModal
          visible={awaitNiceVisible}
          step={nicePaymentStep}
          errorMessage={niceErrorMessage}
          onReset={handleNiceRefundFlowResetProcessing}
          onReStart={() => {
            handleNiceRefundFlowSelectProcessing(true);
          }}
          onCancel={() => setVisible(false)}
        />
      )}
    </>
  );
};

export default ChangePaymentModal;